const ITEMS = [
  "Aviation Industry Specialist",
  "Whole-of-Market Advice",
  "90+ UK Lenders",
  "Plain English, Always",
  "Message Me Anytime",
  "First-Time Buyer Friendly",
  "Remortgage & Buy-to-Let",
];

export default function Marquee() {
  const row = (ariaHidden) => (
    <div
      aria-hidden={ariaHidden}
      className="flex items-center shrink-0"
    >
      {ITEMS.map((item) => (
        <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
          <span className="font-mono text-xs sm:text-sm tracking-[0.25em] uppercase text-slate-500 whitespace-nowrap">
            {item}
          </span>
          <span className="mx-8 h-1.5 w-1.5 rotate-45 bg-amber-400/50 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-[#052B38]/50 py-5 overflow-hidden"
    >
      <div className="kw-marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
